var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "note") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#758091",
    d: "M22.285 20.574h9.714v-18.861c0-0.001 0-0.002 0-0.004 0-0.944-0.766-1.71-1.71-1.71-0.002 0-0.004 0-0.006 0h-28.569c-0.001 0-0.002 0-0.004 0-0.944 0-1.71 0.766-1.71 1.71 0 0.001 0 0.002 0 0.004v-0 28.571c0 0.001 0 0.002 0 0.004 0 0.944 0.766 1.71 1.71 1.71 0.001 0 0.002 0 0.004 0h18.857v-9.714c0.005-0.944 0.77-1.707 1.713-1.71h0zM31.499 24.493l-7.001 7.001c-0.31 0.309-0.738 0.501-1.21 0.501-0.002 0-0.003 0-0.005 0h-0.429v-9.138h9.142v0.436c-0.001 0.469-0.191 0.893-0.497 1.201l0-0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote);
export default __webpack_public_path__ + "static/media/note.bb08ee3cc62b71dd8e9a5d6b32e834c7.svg";
export { ForwardRef as ReactComponent };